import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopUpProvider } from '../../../../types/types';



const initialState:TopUpProvider[] = []

const topUpProviders = createSlice({
  name: 'topUpProviders',
  initialState,
  reducers: {
    setTopUpProviders(state,action:PayloadAction<TopUpProvider[]>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default topUpProviders.reducer;

// Actions
export const {setTopUpProviders} = topUpProviders.actions;

